/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetStudentHousingProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetStudentHousing = ({
  streetName,
  cityName,
}: ContentStreetStudentHousingProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Looking for student housing in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for student housing on ${streetName} in ${cityName}? Explore Kamernet for
        options tailored to your needs. The availability of student
        accommodation on ${streetName} is becoming more desired as more students seek
        accommodations in ${cityName}. Whether it's apartments, rooms, studios, or
        dormitories, Kamernet helps you find your perfect match. Renting student
        rooms on ${streetName} offers a sense of community and affordability. With
        options for single rooms or shared living, there's something for every
        student's budget. Discover listings on Kamernet for cost-effective and
        inclusive living experiences. Find affordable student housing options on
        ${streetName} in ${cityName} on Kamernet. From budget-friendly rooms to apartments
        and studios, find accommodations that fit your financial constraints
        without compromising on quality. Start your search today!`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Op zoek naar studentenwoningen in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar een studentenwoning in ${streetName} in ${cityName}? Ontdek Kamernet
        voor opties op basis van jouw wensen. De beschikbaarheid van
        studentenwoningen in ${streetName} wordt steeds gewilder naarmate meer
        studenten op zoek gaan naar een woning in ${cityName}. Of het nu gaat om
        appartementen, kamers, studio's of slaapzalen, Kamernet helpt je bij het
        vinden van jouw perfecte match. Het huren van een studentenkamer in
        ${streetName} biedt een gemeenschapsgevoel en betaalbaarheid. Met opties voor
        eenpersoonskamers of gedeeld wonen, is er iets voor elk studentenbudget.
        Ontdek advertenties op Kamernet voor betaalbare en inclusieve
        woonervaringen. Vind betaalbare studentenwoningen in ${streetName} in ${cityName}
        op Kamernet. Van budgetvriendelijke kamers tot appartementen en
        studio's, vind woningen die passen bij je financiële beperkingen zonder
        in te leveren op kwaliteit. Begin vandaag nog met zoeken!`}
      </Typography>
    </React.Fragment>
  );
};
